import { render, staticRenderFns } from "./RadioGroup.vue?vue&type=template&id=85b6bad6&scoped=true&"
import script from "./RadioGroup.vue?vue&type=script&lang=js&"
export * from "./RadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b6bad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85b6bad6')) {
      api.createRecord('85b6bad6', component.options)
    } else {
      api.reload('85b6bad6', component.options)
    }
    module.hot.accept("./RadioGroup.vue?vue&type=template&id=85b6bad6&scoped=true&", function () {
      api.rerender('85b6bad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/RadioGroup.vue"
export default component.exports